import axios from "axios";

export default defineNuxtPlugin((app) => {
  const { $logInfo } = app;
  const $njordaEmbedB2BApi = axios.create();
  const { njordaApiBaseUrl, isDevelopment } = useRuntimeConfig().public;
  const getEmbedB2BApiClient = (API_TOKEN: string, baseURI = "b2b/v1/") => {
    $njordaEmbedB2BApi.interceptors.request.use(
      function (config) {
        config.baseURL = `${njordaApiBaseUrl}/${baseURI}`;
        // config.withCredentials = true;
        config.headers.Authorization = `Bearer ${API_TOKEN}`;
        return config;
      },
      function (e) {
        return Promise.reject(e);
      },
    );

    $njordaEmbedB2BApi.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error && axios.isCancel(error) && isDevelopment) {
          $logInfo(">>> API request cancelled");
        }
        return Promise.reject(error);
      },
    );

    return $njordaEmbedB2BApi;
  };

  return {
    provide: {
      getEmbedB2BApiClient,
    },
  };
});
